<template>
    <span
        class="VDropdownBlock"
        v-click-outside="close"
    >
        <slot name="button"><VButton></VButton></slot>
        <div class="VDropdownBlock-dropdown">
           <slot name="dropdown"></slot>
        </div>
    </span>
</template>

<script>
    export default {
        name: 'VDropdownBlock',
        methods: {
            close() {
                this.$emit('close');
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .VDropdownBlock {
        position: relative;
        
        &-dropdown {
            z-index: 9;
            width: 390px;
            position: absolute;
            left: 0;
            padding: 15px;
            background: #FFFFFF;
            border-radius: 15px;
            display: flex;
            flex-direction: column;
      
            div {
                display: flex;
                text-align: left;
                margin-bottom: 20px;
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }

</style>
